export const SIGN_IN_STEPS = [
  'NONE',
  'CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE',
  'CONTINUE_SIGN_IN_WITH_MFA_SELECTION',
  'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED',
  'CONFIRM_SIGN_IN_WITH_SMS_CODE',
  'CONFIRM_SIGN_IN_WITH_TOTP_CODE',
  'CONFIRM_SIGN_IN_WITH_EMAIL_CODE',
  'CONTINUE_SIGN_IN_WITH_TOTP_SETUP',
  'CONTINUE_SIGN_IN_WITH_EMAIL_SETUP',
  'CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION',
  'CONTINUE_SIGN_IN_WITH_FIRST_FACTOR_SELECTION',
  'CONFIRM_SIGN_IN_WITH_PASSWORD',
  'CONFIRM_SIGN_UP',
  'CONFIRM_RESET_PASSWORD_WITH_CODE',
  'RESET_PASSWORD',
  'DONE',
] as const;
export type AuthSignInStep = (typeof SIGN_IN_STEPS)[number];

export type AuthUser = {
  attributes?: {
    sub: string;
    email: string;
    ['phone_number']: string;
    ['phone_number_verified']: boolean;
  };
  preferredMFA?: 'SMS' | 'TOTP' | 'EMAIL';
};

export type AuthStatus =
  | 'none'
  | 'signIn'
  | 'confirmSignIn'
  | 'requireNewPassword'
  | 'requireMfa'
  | 'forgotPassword'
  | 'resetPassword'
  | 'signedIn';

export type AuthState = {
  status: AuthStatus;
  user?: AuthUser;
};

export type AuthPayload = {
  clientId: string;
  accessToken: string;
  expireTime: number;
  keepaliveInterval: string;
  backendId?: string;
  mgmtDeptId?: string;
  organizationId?: string;
  mfa: 'optional' | 'required';
};
